import src from "IMAGE";
export default { src, width: 128, height: 27, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AGUdElKGJxhubyAUW3IhFV5qHxNWbB8UWG4gFF5tIBRWAD4SCzRkHRJOShUNPmIcElViHRJTWhoQSlsaEFNIFQ0581AOKrEvBeUAAAAASUVORK5CYII="};
